export function createElementFromHTML<T>(htmlString: string): T {
  const div = document.createElement('div')
  div.innerHTML = htmlString.trim()
  return div.firstChild as any as T
}
